import React from 'react'
import './JobsPage.css';
function RecruitmentLinkCandidate() {
  return (
    <>
      <div className="topbar">
  <i className="fa-solid fa-link topbar-icon"></i>

  <div className="breadcrumb breadcrumb-reset">
    <a href="recruitment-jobs.html">Jobs</a>

    <i className="fa-solid fa-chevron-right breadcrumb-chevron"></i>

    <a href="recruitment-job-detail.html">
      JOB-2026-001
    </a>

    <i className="fa-solid fa-chevron-right breadcrumb-chevron"></i>

    <strong className="breadcrumb-current">
      Add Candidate
    </strong>
  </div>

  <div className="top-right">
    <div className="top-user">
      <div className="top-avatar">AM</div>

      <div>
        <div className="top-user-name">
          Arun Mishra
        </div>

        <div className="top-user-role">
          HR Admin
        </div>
      </div>
    </div>
  </div>
</div>

<div className='container-fluid position-relation'>
    <div className="page-hd">
              <div className='Page-head'>
                   <div className='leftside-head'>
              <h2>
                <i className="fa-solid fa-link"></i>
                Add Candidate to Job
              </h2>
              <div className="breadcrumb">Fill in job details, requirements and visibility settings</div>
            </div> 

            <button className="btn btn-outline btn-sm" onClick={() => window.location.href = 'recruitment-jobs.html'}>
              <i className="fa-solid fa-arrow-left"></i> Back to Jobs
            </button>
              </div>
          </div>


<div className="page-layout">

  {/* Left: Job context */}
  <div className="job-context">

    <div className="jc-header">
      <div className="job-code">
        JOB-2026-001
      </div>

      <div className="jc-header-title">
        Senior Frontend Developer
      </div>

      <div className="jc-header-sub">
        Engineering · Delhi · Hybrid · Full-time
      </div>

      <div className="job-tags">
        <span className="job-tag">React</span>
        <span className="job-tag">TypeScript</span>
        <span className="job-tag">3–6 yrs</span>
      </div>
    </div>

    <div className="jc-stat-row">
      <div className="jc-stat">
        <div className="jc-stat-val jc-stat-primary">
          3
        </div>
        <div className="jc-stat-lbl">
          Openings
        </div>
      </div>

      <div className="jc-stat">
        <div className="jc-stat-val jc-stat-blue">
          18
        </div>
        <div className="jc-stat-lbl">
          In Pipeline
        </div>
      </div>

      <div className="jc-stat">
        <div className="jc-stat-val jc-stat-green">
          4
        </div>
        <div className="jc-stat-lbl">
          Shortlisted
        </div>
      </div>
    </div>

    {/* Pipeline Stages */}
    <div className="pipeline-section-bx">
      <div className="pipeline-title">
        Pipeline Stages
      </div>

      <div className="pipeline-list">

        <div className="pipeline-item">
          <span className="pipeline-label">
            <span className="pipeline-dot dot-applied"></span>
            Applied
          </span>
          <strong>5</strong>
        </div>

        <div className="pipeline-item">
          <span className="pipeline-label">
            <span className="pipeline-dot dot-interview"></span>
            Interview
          </span>
          <strong>6</strong>
        </div>

        <div className="pipeline-item">
          <span className="pipeline-label">
            <span className="pipeline-dot dot-shortlisted"></span>
            Shortlisted
          </span>
          <strong>4</strong>
        </div>

        <div className="pipeline-item">
          <span className="pipeline-label">
            <span className="pipeline-dot dot-offer"></span>
            Offer Given
          </span>
          <strong>2</strong>
        </div>

        <div className="pipeline-item">
          <span className="pipeline-label">
            <span className="pipeline-dot dot-rejected"></span>
            Rejected
          </span>
          <strong>1</strong>
        </div>

      </div>
    </div>

    <div className="pipeline-section-bx">
      <button
        className="btn btn-primary btn-sm upload-btn"
        onClick={() =>
          (window.location.href = "recruitment-cv-upload.html")
        }
      >
        <i className="fa-solid fa-cloud-arrow-up"></i>
        Upload New CV Instead
      </button>
    </div>

  </div>

  {/* Right: Candidate Search */}
  <div>

    <div className="search-bar">

      <div className="search-controls">

        <div className="search-input-wrap">
          <i className="fa-solid fa-magnifying-glass search-icon"></i>

          <input
            className="og-input candidate-search-input ps-4"
            id="candSearch"
            placeholder="Search name, email, phone, skills…"
           
          />
        </div>

        <button
          className="btn btn-primary btn-sm"
          onClick={() =>
            (window.location.href =
              "recruitment-candidate-add.html")
          }
        >
          <i className="fa-solid fa-user-plus"></i>
          Add New Candidate
        </button>

      </div>

      {/* Skill Filters */}
      <div className="filter-chips">
        <span className="filter-label">
          Filter by skill:
        </span>

        <button
          className="fc-bx active"
         
        >
          React
        </button>

        <button
          className="fc-bx"
          
        >
          TypeScript
        </button>

        <button
          className="fc-bx"
          
        >
          Vue.js
        </button>

        <button
          className="fc-bx"
          
        >
          Angular
        </button>

        <button
          className="fc-bx"
          
        >
          Next.js
        </button>

        <button
          className="fc-bx"
          
        >
          CSS
        </button>
      </div>

      {/* Filters */}
      <div className="candidate-filters">

        <div>
          <select className="og-select candidate-filter-select">
            <option>Any Stage</option>
            <option>Applied</option>
            <option>Shortlisted</option>
            <option>Offer</option>
            <option>Rejected</option>
          </select>
        </div>

        <div>
          <select className="og-select candidate-filter-select">
            <option>Any Exp.</option>
            <option>0–2 yrs</option>
            <option>2–4 yrs</option>
            <option>4–6 yrs</option>
            <option>6+ yrs</option>
          </select>
        </div>

        <div>
          <select className="og-select candidate-filter-select">
            <option>Any Location</option>
            <option>Delhi</option>
            <option>Noida</option>
            <option>Gurgaon</option>
            <option>Mumbai</option>
            <option>Bengaluru</option>
            <option>Remote</option>
          </select>
        </div>

        <div>
          <select className="og-select candidate-filter-select">
            <option>Any Source</option>
            <option>ATS</option>
            <option>HR Upload</option>
            <option>Referral</option>
            <option>Job Portal</option>
          </select>
        </div>

        <div>
          <select className="og-select candidate-filter-select">
            <option>Salary: Any</option>
            <option>Under 10 LPA</option>
            <option>10–15 LPA</option>
            <option>15–20 LPA</option>
            <option>20+ LPA</option>
          </select>
        </div>

      </div>
    </div>

    {/* Result Count */}
    <div className="result-count" id="resultCount">
      Showing 5 candidates from database ·{" "}
      <span className="pipeline-warning">
        2 already in this job's pipeline
      </span>
    </div>

    <div id="candResults">

      {/* Rahul Kumar */}
      <div className="cand-result" data-name="Rahul Kumar">

        <div className="cr-av candidate-avatar-blue">
          RK
        </div>

        <div className="cr-info">

          <div
            className="cr-name candidate-name"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            Rahul Kumar
          </div>

          <div className="cr-role">
            Senior Frontend Developer · 5 yrs
          </div>

          <div className="cr-meta">

            <span>
              <i className="fa-solid fa-location-dot meta-icon"></i>
              Delhi
            </span>

            <span>
              <i className="fa-solid fa-indian-rupee-sign meta-icon"></i>
              14–18 LPA
            </span>

            <span>
              <i className="fa-solid fa-user-clock meta-icon"></i>
              30 days
            </span>

            <span className="source-badge source-ats">
              Source: ATS
            </span>

          </div>

          <div className="cr-skills">
            <span className="skill-chip">React</span>
            <span className="skill-chip">TypeScript</span>
            <span className="skill-chip">Next.js</span>
            <span className="skill-chip">Redux</span>
          </div>

          <div className="cr-last-job">
            <i className="fa-solid fa-briefcase last-job-icon"></i>
            Already in JOB-2026-001 · Interview Stage · 3 days ago
          </div>

          <div className="cr-note">
            Already in this job's pipeline — adding again will create duplicate
          </div>

        </div>

        <div className="cr-actions">

          <button
            className="btn btn-secondary btn-xs"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            <i className="fa-solid fa-eye"></i>
            View Profile
          </button>

          <button
            className="btn btn-outline btn-xs duplicate-btn"
            disabled
          >
            Already Added
          </button>

        </div>
      </div>

      {/* Meera Joshi */}
      <div className="cand-result" data-name="Meera Joshi">

        <div className="cr-av candidate-avatar-cyan">
          MJ
        </div>

        <div className="cr-info">

          <div
            className="cr-name candidate-name"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            Meera Joshi
          </div>

          <div className="cr-role">
            Full Stack Developer · 4 yrs
          </div>

          <div className="cr-meta">

            <span>
              <i className="fa-solid fa-location-dot meta-icon"></i>
              Bengaluru
            </span>

            <span>
              <i className="fa-solid fa-indian-rupee-sign meta-icon"></i>
              12–16 LPA
            </span>

            <span>
              <i className="fa-solid fa-user-clock meta-icon"></i>
              Immediate
            </span>

            <span className="source-badge source-hr">
              Source: HR Upload
            </span>

          </div>

          <div className="cr-skills">
            <span className="skill-chip">React</span>
            <span className="skill-chip">Node.js</span>
            <span className="skill-chip">MongoDB</span>
            <span className="skill-chip">TypeScript</span>
          </div>

          <div className="cr-last-job">
            <i className="fa-solid fa-briefcase last-job-icon"></i>
            Last: JOB-2026-002 · Screening Stage · 5 days ago
          </div>

          <div className="cr-note">
            "Strong frontend skills, confident in React. Worth considering."
          </div>

        </div>

        <div className="cr-actions">

          <button
            className="btn btn-outline btn-xs"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            <i className="fa-solid fa-eye"></i>
            Profile
          </button>

          <select className="stage-select" id="stage-MJ">
            <option>Applied</option>
            <option>Screening</option>
            <option>Interview</option>
          </select>

          <button
            className="btn btn-primary btn-xs"
            
          >
            <i className="fa-solid fa-plus"></i>
            Add to Pipeline
          </button>

        </div>
      </div>

      {/* Siddharth Rao */}
      <div className="cand-result" data-name="Siddharth Rao">

        <div className="cr-av candidate-avatar-green">
          SR
        </div>

        <div className="cr-info">

          <div
            className="cr-name candidate-name"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            Siddharth Rao
          </div>

          <div className="cr-role">
            Frontend Engineer · 5 yrs
          </div>

          <div className="cr-meta">

            <span>
              <i className="fa-solid fa-location-dot meta-icon"></i>
              Bengaluru
            </span>

            <span>
              <i className="fa-solid fa-indian-rupee-sign meta-icon"></i>
              15–20 LPA
            </span>

            <span>
              <i className="fa-solid fa-user-clock meta-icon"></i>
              30 days
            </span>

            <span className="source-badge source-referral">
              Source: Referral
            </span>

          </div>

          <div className="cr-skills">
            <span className="skill-chip">React</span>
            <span className="skill-chip">TypeScript</span>
            <span className="skill-chip">GraphQL</span>
            <span className="skill-chip">AWS</span>
          </div>

          <div className="cr-last-job">
            <i className="fa-solid fa-briefcase last-job-icon"></i>
            New candidate · Added today via ATS
          </div>

          <div className="cr-note">
            No notes yet
          </div>

        </div>

        <div className="cr-actions">

          <button
            className="btn btn-outline btn-xs"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            <i className="fa-solid fa-eye"></i>
            Profile
          </button>

          <select className="stage-select" id="stage-SR">
            <option>Applied</option>
            <option>Screening</option>
            <option>Interview</option>
          </select>

          <button
            className="btn btn-primary btn-xs"
           
          >
            <i className="fa-solid fa-plus"></i>
            Add to Pipeline
          </button>

        </div>
      </div>

      {/* Anjali Verma */}
      <div className="cand-result" data-name="Anjali Verma">

        <div className="cr-av candidate-avatar-amber">
          AV
        </div>

        <div className="cr-info">

          <div
            className="cr-name candidate-name"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            Anjali Verma
          </div>

          <div className="cr-role">
            React Developer · 3.5 yrs
          </div>

          <div className="cr-meta">

            <span>
              <i className="fa-solid fa-location-dot meta-icon"></i>
              Delhi
            </span>

            <span>
              <i className="fa-solid fa-indian-rupee-sign meta-icon"></i>
              10–13 LPA
            </span>

            <span>
              <i className="fa-solid fa-user-clock meta-icon"></i>
              45 days
            </span>

            <span className="source-badge source-naukri">
              Source: Naukri
            </span>

          </div>

          <div className="cr-skills">
            <span className="skill-chip">React</span>
            <span className="skill-chip">JavaScript</span>
            <span className="skill-chip">CSS</span>
            <span className="skill-chip">Redux</span>
          </div>

          <div className="cr-last-job">
            <i className="fa-solid fa-briefcase last-job-icon"></i>
            Last: JOB-2025-088 · Rejected after R1 · 3 months ago
          </div>

          <div className="cr-note">
            "Good CSS but weak TypeScript. Improving."
          </div>

        </div>

        <div className="cr-actions">

          <button
            className="btn btn-outline btn-xs"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            <i className="fa-solid fa-eye"></i>
            Profile
          </button>

          <select className="stage-select" id="stage-AV">
            <option>Applied</option>
            <option>Screening</option>
          </select>

          <button
            className="btn btn-primary btn-xs"
           
          >
            <i className="fa-solid fa-plus"></i>
            Add to Pipeline
          </button>

        </div>
      </div>

      {/* Vikram Patel */}
      <div className="cand-result" data-name="Vikram Patel">

        <div className="cr-av candidate-avatar-purple">
          VP
        </div>

        <div className="cr-info">

          <div
            className="cr-name candidate-name"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            Vikram Patel
          </div>

          <div className="cr-role">
            Senior UI Engineer · 6 yrs
          </div>

          <div className="cr-meta">

            <span>
              <i className="fa-solid fa-location-dot meta-icon"></i>
              Mumbai
            </span>

            <span>
              <i className="fa-solid fa-indian-rupee-sign meta-icon"></i>
              16–20 LPA
            </span>

            <span>
              <i className="fa-solid fa-user-clock meta-icon"></i>
              60 days
            </span>

            <span className="source-badge source-linkedin">
              Source: LinkedIn
            </span>

          </div>

          <div className="cr-skills">
            <span className="skill-chip">React</span>
            <span className="skill-chip">TypeScript</span>
            <span className="skill-chip">Next.js</span>
            <span className="skill-chip">Storybook</span>
          </div>

          <div className="cr-last-job">
            <i className="fa-solid fa-briefcase last-job-icon"></i>
            No previous applications
          </div>

          <div className="cr-note">
            No notes yet — review profile before adding
          </div>

        </div>

        <div className="cr-actions">

          <button
            className="btn btn-outline btn-xs"
            onClick={() =>
              (window.location.href =
                "recruitment-candidate-profile.html")
            }
          >
            <i className="fa-solid fa-eye"></i>
            Profile
          </button>

          <select className="stage-select" id="stage-VP">
            <option>Applied</option>
            <option>Screening</option>
            <option>Interview</option>
          </select>

          <button
            className="btn btn-primary btn-xs"
           
          >
            <i className="fa-solid fa-plus"></i>
            Add to Pipeline
          </button>

        </div>
      </div>

    </div>

    {/* Pagination */}
    <div className="pagination-wrapper">

      <span className="pagination-info">
        Showing 5 of 143 candidates
      </span>

      <div className="pagination-buttons">

        <button
          className="btn btn-outline btn-sm pagination-disabled"
          disabled
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>

        <button className="btn btn-primary btn-sm">
          1
        </button>

        <button className="btn btn-outline btn-sm">
          2
        </button>

        <button className="btn btn-outline btn-sm">
          3
        </button>

        <span className="pagination-dots">
          …
        </span>

        <button className="btn btn-outline btn-sm">
          29
        </button>

        <button className="btn btn-outline btn-sm">
          <i className="fa-solid fa-chevron-right"></i>
        </button>

      </div>
    </div>

  </div>
</div>
</div>
    </>
  )
}

export default RecruitmentLinkCandidate